import { UiFloatModal } from '../../common/modal/index'
import styles from '../../trend/table/table.css'

const tdWithName = (name, color, x, y) => `
    <tr>
        <td style="padding: 0;"><div style="border-left: 4px solid ${color}; padding: 7px 40px 7px 10px;">${name}</div></td>
        <td>${x}</td>
        <td>${y}</td>
    </tr>
`
const tdWithoutName = (x, y) => `
    <tr>
        <td></td>
        <td>${x}</td>
        <td>${y}</td>
    </tr>
`

const template = `
    <style>
        ${styles}
    </style>
    <div class="table-main-container">
        <table id="table">
        </table>
    </div>
`

const headerTable = `
   <tr>
        <td></td>
        <td>x</td>
        <td>y</td>
    </tr>
`

export class TrendTable {
    constructor(root, btn) {
        this.root = root
        this.btn = btn
        this.init()
    }

    init(){
        this.modal = new UiFloatModal(template)
        this.modal.modalComponent.label = "Таблица значений"
        this.modal.modalComponent.calculateInitialPosition = () => {
            const { top, left } = this.root.getBoundingClientRect()
            // 20 - это дополнительный отступ, чтобы не прилипало к верху
            return [left, top + 20]
        }
        this.btn.addEventListener('click', this.toggle.bind(this))
        this.table = this.modal.modalComponent.querySelector('#table')
    }

    toggle() {
        this.modal.modalComponent.toggle()
        if (!this.modal.modalComponent.active) return
    }

    render(){
        const params = []
        this.root.pens.forEach(pen => {
            const param = {
                name: pen.name,
                color: pen.color,
                data: [...pen.serie.data]
            }
            params.push(param)
        });
        let htmlResult = ''
        params.forEach((param) => {
            if(param.data.length){
                htmlResult += tdWithName(param.name, param.color, param.data[0][0], param.data[0][1])
                for (let i = 1; i < param.data.length; i++) {
                    const data = param.data[i];
                    htmlResult += tdWithoutName(data[0], data[1])
                }
            }
        })
        this.table.innerHTML = headerTable + htmlResult
    }

    destroy() {
        if (this.modal) {
            this.modal.modalComponent.delete()
            this.modal = null;
        }
    }
}
